var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-center h-100" }, [
      _c("div", { staticClass: "badge-wrapper" }, [
        _c("span", { staticClass: "badge text-body-4-bold" }, [_vm._v("SOON")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }